import { FC, useMemo } from 'react';
import classnames from 'classnames';

import { FormItem, SelectField, TextField } from 'componets/form';

import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'hooks';

import { Rules } from 'utils/constants';
import { selectCountries, selectUserSettings } from 'selectors';
import { Country } from 'models';

import s from './index.module.scss';

export const SettingsAddressCard: FC<{ isUser?: boolean }> = ({ isUser = false }) => {
	const { t } = useTranslation();
	const countryPlaceholder = isUser ? t('countryResidenceText') : t('countryRegistrationText');

	const countries = useAppSelector(selectCountries);
	const settings = useAppSelector(selectUserSettings);

	const countriesOptions = useMemo(() => {
		const currentCountry =
			countries?.find((item) => +item.id === +settings.country_id) || ({} as Country);

		return countries
			?.filter((item) => item.activeForRegistration || item.id === currentCountry.id)
			.map((item) => {
				return {
					label: item.label,
					value: item.id,
				};
			});
	}, [countries, settings.country_id]);

	return (
		<>
			<FormItem
				name="country_id"
				rules={[Rules.REQUIRED_SELECT]}
				className={classnames(s.col, s.addressInput, s.gridItem)}
			>
				<SelectField options={countriesOptions} placeholder={countryPlaceholder} isFilter />
			</FormItem>
			<FormItem
				name="city"
				rules={[Rules.REQUIRED, Rules.MAX_LENGTH('city', 50)]}
				className={classnames(s.col, s.input, s.gridItem)}
			>
				<TextField label={t('cityText')} />
			</FormItem>
			<FormItem
				name="address"
				rules={[Rules.REQUIRED, Rules.MAX_LENGTH('address', 255)]}
				className={classnames(s.col, s.addressInput, s.gridItem)}
			>
				<TextField label={t('addressLabelSettingsText')} />
			</FormItem>
			<FormItem
				name="zip"
				rules={[Rules.REQUIRED, Rules.MAX_LENGTH('zip', 20)]}
				className={classnames(s.col, s.input, s.gridItem)}
			>
				<TextField label={t('zipCodeText')} />
			</FormItem>
		</>
	);
};
